// extracted by mini-css-extract-plugin
export default {"background":"Customers_background__16lyT","row":"Customers_row__2nOMf","col":"Customers_col__m-ovw","card":"Customers_card__HKuup"};